module.exports = {
  newSearchAndFolderView: 'assignment_new_search_and_folder_view',
  lcbOpenSection: 'lock_sections_lcb_open_section_button',
  switchAccountView: 'switch_account_view',
  dashboardToggle: 'dashboard_toggle',
  newDashboardOverviewSteps: 'new_dashboard_overview_steps',
  itemDetailsChangeQuestionType: 'item_details_change_question_type',
  teacherCommonDistrictSetting: 'teacher_common_dsitrict_setting',
  assignmentSettingsChanges: 'assignment_settings_changes',
}
